/**
 * Shell helpers for the Meetday UI.
 * - Toggles the "dark" class on <html> and persists to localStorage.
 * - Registers the service worker for PWA installability and offline caching.
 */
(function () {
  var STORAGE_KEY = "meetday_theme";

  function applySavedTheme() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    } catch (_) {}
  }

  function toggleTheme() {
    var isDark = document.documentElement.classList.toggle("dark");
    try {
      localStorage.setItem(STORAGE_KEY, isDark ? "dark" : "light");
    } catch (_) {}
  }

  function setTheme(theme) {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
      try {
        localStorage.setItem(STORAGE_KEY, "dark");
      } catch (_) {}
    } else {
      document.documentElement.classList.remove("dark");
      try {
        localStorage.setItem(STORAGE_KEY, "light");
      } catch (_) {}
    }
  }

  window.meetdayToggleTheme = toggleTheme;
  window.meetdaySetTheme = setTheme;
  applySavedTheme();

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", function () {
      var swPath = "/sw.js";
      navigator.serviceWorker
        .register(swPath, { updateViaCache: "none" })
        .then(function (registration) {
          registration.update();
        })
        .catch(function () {
          // Best-effort; ignore failures.
        });
    });
  }
})();
